export default __webpack_public_path__ + "maps-examples-tracking-mode-1200-063de2f7add6cd1971406ba2fbb25d13.png";